import slice from '../reducer/slice';
const { setSelectedCoordinates } = slice.actions;

type TOperation = (coordinates?: string) => void;

const operation: TOperation = (coordinates = '') =>
  setSelectedCoordinates(coordinates);

export default operation;
